enum DashboardRunType {
	USER = 'USER',
	PDF = 'PDF',
	SCHEDULED_PDF = 'SCHEDULED_PDF',
	DASHBOARD_PREVIEW = 'DASHBOARD_PREVIEW'
}

export default DashboardRunType;
